export const DISPLAY_GDPR_ROADBLOCK = 'DISPLAY_GDPR_ROADBLOCK';

export const displayGDPRRoadblock = value => ({
    type: DISPLAY_GDPR_ROADBLOCK,
    payload: {
        value,
    },
});
